<h1 class="h2">Questionset Test</h1>


<app-questionset-surveyjs *ngIf="jsonData"
                          [questionsetData]="jsonData"
                          [authUser]="authUser"
                          [account]="account"></app-questionset-surveyjs>

